<div class="is-flex flex-column">
    <span class="title-l ttu text-center mb-16">
        {{ (hasSubOrders ? 'dev.orders.suborder.cancel.title' : 'dev.orders.order.cancel.title') | translate }}
    </span>
    <span class="text-l mb-20">
        {{ (hasSubOrders ? 'dev.orders.suborder.cancel.subtitle' : 'dev.orders.order.cancel.subtitle') | translate }}
    </span>
    <button class="btn btn-secondary mb-16" (click)="closeDialog()">
        {{ (hasSubOrders ? 'dev.orders.suborder.cancel.maintain' : 'dev.orders.order.cancel.maintain') | translate }}
    </button>
    <button class="btn btn-primary" (click)="cancelOrder()">
        {{ (hasSubOrders ? 'dev.orders.suborder.cancel' : 'dev.orders.order.cancel') | translate }}
    </button>
</div>
